import { Action, Reducer } from 'redux';
// import { delay } from 'redux-saga';
// import { fork, call, takeEvery, put, all, select } from 'redux-saga/effects';
import { fork, call, takeEvery, select, put } from 'redux-saga/effects';

import Api from '../api';

import { actionCreators as layoutActionCreators } from '../reducers/Layout';
import { selectors as authSelectors } from '../reducers/Auth';
import SearchResult from 'src/models/OwnerSearchResult';
import { IRootState } from './index';
import TextHelper from 'src/util/Text';

// import { IRootState } from './index';
// import { ODataOptions } from 'src/util/ODataBuilder';

export interface ISearchState {
    isLoadingSearch: boolean;
    searchResults: Array<SearchResult>;
    verifyIdResult: string;
    idExists: boolean;
}

const initialState: ISearchState = {
    isLoadingSearch: false,
    searchResults: undefined,
    verifyIdResult: '',
    idExists: false,
};

export enum actionTypes {
    GET_SEARCH = '[search] GET_SEARCH',
    GET_SEARCH_SUCCESS = '[search] GET_SEARCH_SUCCESS',
    CLEAR_SEARCH_RESULTS = '[search] CLEAR_SEARCH_RESULTS',
    VERIFY_ID = '[search] VERIFY_ID',
    VERIFY_ID_SUCCESS = '[search] VERIFY_ID_SUCCESS',
    CLEAR_VERIFICATION = '[search] CLEAR_VERIFICATION',
    SET_VERIFICATION_MESSAGE = '[search] SET_VERIFICATION_MESSAGE',
}

export const actionCreators = {
    getSearch: (searchText: string) => {
        return { type: actionTypes.GET_SEARCH, payload: searchText };
    },
    getSearchSuccess: (results: Array<SearchResult>) => {
        return { type: actionTypes.GET_SEARCH_SUCCESS, payload: results };
    },
    clearSearchResults: () => {
        return { type: actionTypes.CLEAR_SEARCH_RESULTS };
    },
    verifyId: (context: string, id: string) => {
        return { type: actionTypes.VERIFY_ID, payload: { context, id } };
    },
    verifyIdSuccess: (idExists: boolean, message: string) => {
        return { type: actionTypes.VERIFY_ID_SUCCESS, payload: { idExists, message } };
    },
    clearVerification: () => {
        return { type: actionTypes.CLEAR_VERIFICATION };
    },
    setVerificationMessage: (message: string) => {
        return { type: actionTypes.SET_VERIFICATION_MESSAGE, payload: message };
    },
};

const reducer: Reducer<ISearchState> = (state: ISearchState = initialState, action: Action): ISearchState => {
    switch (action.type) {
        case actionTypes.GET_SEARCH:
            return {
                ...state,
                isLoadingSearch: true,
            };
        case actionTypes.GET_SEARCH_SUCCESS: {
            const payload = (action as { type: string; payload: Array<SearchResult> }).payload;
            return {
                ...state,
                isLoadingSearch: false,
                searchResults: payload,
            };
        }
        case actionTypes.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: undefined,
            };
        case actionTypes.VERIFY_ID_SUCCESS: {
            const payload = (action as { type: string; payload: { idExists: boolean; message: string } }).payload;
            return {
                ...state,
                idExists: payload.idExists,
                verifyIdResult: payload.message,
            };
        }
        case actionTypes.CLEAR_VERIFICATION: {
            return {
                ...state,
                idExists: false,
                verifyIdResult: '',
            };
        }
        case actionTypes.SET_VERIFICATION_MESSAGE: {
            const payload = (action as { type: string; payload: string }).payload;
            console.log(action, payload);
            return {
                ...state,
                idExists: false,
                verifyIdResult: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

const searchResultSelector = (state: IRootState): Array<SearchResult> => state.search.searchResults;

export const selectors = {
    searchResults: searchResultSelector,
    loading: (state: IRootState) => state.search.isLoadingSearch,
};

const sagas = {
    getSearch: function* (action: { type: string; payload: string }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const result = yield call(Api.Search.search, action.payload, jwt);
        yield put(actionCreators.getSearchSuccess(result));
    },
    verifyId: function* (action: { type: string; payload: { context: string; id: string } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);
        const { context, id } = action.payload;
        const result = yield call(Api.Search.verifyId, context, id, jwt);
        yield put(
            actionCreators.verifyIdSuccess(
                result.result,
                result.result ? `${TextHelper.toProperCase(context)} found` : `${TextHelper.toProperCase(context)} not found`
            )
        );
    },
};

const watches = {
    getSearch: function* () {
        yield takeEvery(actionTypes.GET_SEARCH, sagas.getSearch);
    },
    verifyId: function* () {
        yield takeEvery(actionTypes.VERIFY_ID, sagas.verifyId);
    },
};

export function* saga() {
    yield fork(watches.getSearch);
    yield fork(watches.verifyId);
}



// WEBPACK FOOTER //
// ./src/reducers/Search.ts